import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ProjectId } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { useProjectDetail } from 'data/projects';
import { useCustomerPreview } from 'hooks/use-customer-preview';
import { PreviewBanner } from './banner';
import { PreviewLoader as Loader } from './loader';
import { disabledStyles as DisabledControls } from './styles';
const Preview = ({ projectId })=>{
    var _project_customer, _window_location_pathname_includes, _window_location_pathname, _window_location;
    const [showLoader, setShowLoader] = useState(true);
    const { data: project } = useProjectDetail(projectId);
    const customerName = project === null || project === void 0 ? void 0 : (_project_customer = project.customer) === null || _project_customer === void 0 ? void 0 : _project_customer.companyName;
    window.setTimeout(()=>setShowLoader(false), 3000);
    if (((_window_location = window.location) === null || _window_location === void 0 ? void 0 : (_window_location_pathname = _window_location.pathname) === null || _window_location_pathname === void 0 ? void 0 : (_window_location_pathname_includes = _window_location_pathname.includes) === null || _window_location_pathname_includes === void 0 ? void 0 : _window_location_pathname_includes.call(_window_location_pathname, 'live-customer-portal')) || window.top !== window) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DisabledControls, {}),
            showLoader && /*#__PURE__*/ _jsx(Loader, {}),
            customerName && /*#__PURE__*/ _jsx(PreviewBanner, {
                customerName: customerName
            })
        ]
    });
};
export const PreviewWrapper = ({ children })=>{
    const { isPreview, isPending, projectId } = useCustomerPreview();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isPreview ? projectId != null ? /*#__PURE__*/ _jsx(Preview, {
                projectId: ProjectId(projectId)
            }) : null : null,
            isPending ? /*#__PURE__*/ _jsx(PageLoading, {
                size: "large"
            }) : children
        ]
    });
};
